var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarketingTrusted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104,
    height: 104,
    fill: "none",
    viewBox: "0 0 104 104",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M52 104c28.719 0 52-23.281 52-52S80.719 0 52 0 0 23.281 0 52s23.281 52 52 52z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FB7948",
    d: "M36.843 73.619h29.113c1.337 0 2.422-1.106 2.422-2.433 0-1.327-1.096-2.432-2.422-2.432H36.843c-1.337 0-2.423 1.105-2.423 2.432s1.096 2.433 2.423 2.433zm29.114-8.102H36.843c-.664 0-1.237-.382-1.478-.965l-9.64-17.654c-.141-.26-.201-.502-.201-.783 0-.624.31-1.126.844-1.407.433-.242.916-.262 1.337-.101l13.13 4.383 9.097-19.724c.271-.583.855-.925 1.467-.925.614 0 1.197.342 1.468.925l9.098 19.724 13.13-4.383c.421-.16.904-.14 1.326.1.543.282.855.784.855 1.408 0 .28-.06.523-.201.783l-9.641 17.654c-.251.583-.815.965-1.477.965z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketingTrusted);
export default __webpack_public_path__ + "static/media/marketing-trusted.34e1ea2d0894e4cf3233736f8ea14cb1.svg";
export { ForwardRef as ReactComponent };